export default __webpack_public_path__ + "a77d449d31b7d82a00d0010d95f2ab2a.jpg";